import React, { useEffect } from 'react';
import { Row } from 'reactstrap';
import { toast } from 'react-toastify';

import DefaultModal from 'components/Modal/DefaultModal';
import ReactLoader from 'components/Loader';
import Pagination from 'components/Pagination';
import ReceivedCallAnalyticalTable from 'views/Report/Callcenter/ReceivedCall/tables/Analytical';

import { getAnalyticalReceivedCallReport } from 'views/Dashboard/Agent/services/getAnalyticalReceivedCallReport';
import { DEFAULT_PAGE_SIZE } from 'views/Dashboard/Agent/utils/consts';

import { useAnalyticalReportService } from '../../hooks/useAnalyticalReportService';

const ReceivedCallReportModal = ({ isModalOpen, onModalToggle }) => {
  const {
    data,
    quantity,
    loading,
    activePage,
    error,
    handlePageChange,
    fetchData
  } = useAnalyticalReportService(getAnalyticalReceivedCallReport);

  useEffect(() => {
    if (!isModalOpen) return;

    fetchData({
      disposition: 'ANSWERED'
    });
  }, [isModalOpen, activePage]);

  useEffect(() => {
    if (!error) return;

    onModalToggle(false);
    toast.error('Erro ao carregar relatório de chamadas recebidas.');
  }, [error]);

  return (
    <DefaultModal
      show={isModalOpen}
      onModalToggle={onModalToggle}
      title="Relatório de Chamadas Recebidas"
      modalContainerClasses="modal-xl"
      showCloseButton={false}
      centered={false}
    >
      {loading ? (
        <Row className="justify-content-md-center">
          <ReactLoader />
        </Row>
      ) : (
        <ReceivedCallAnalyticalTable
          totalRecords={quantity}
          dataReport={data}
          needPermission={true}
        />
      )}

      {quantity > DEFAULT_PAGE_SIZE && (
        <Pagination
          activePage={activePage}
          totalItemsCount={quantity}
          onChange={handlePageChange}
        />
      )}
    </DefaultModal>
  );
};

export default ReceivedCallReportModal;
